import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "cross-large, crossed large, close" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M4.16602 4.16669L15.8327 15.8334M15.8327 4.16669L4.16602 15.8334",
        stroke: "#8E8E93",
        "stroke-width": "2",
        "stroke-linecap": "round"
      })
    ], -1)
  ])))
}
export default { render: render }